import { subRoutes } from "../../routes/Router/subRoutes";

export const findLegacySubservice = () => {
	return !!subRoutes.find(
		(route) => `/${route}` === window.location.pathname.toLocaleLowerCase()
	);
};
